import { AxiosError } from 'axios';
import { FormikHelpers } from 'formik';
import { toast } from 'react-toastify';
import { ResponseError } from '../../api/error';

const showToast = (msg: string) =>
  toast.error(msg, {
    position: 'top-right',
    autoClose: 1000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
  });

export function useErrorHandler() {
  return <T>(error: ResponseError | AxiosError, formik?: FormikHelpers<T>) => {
    // @ts-ignore
    const data = error?.data || error?.response?.data || null;
    if (!data) {
      return showToast(error.message);
    } else if (data.error) {
      return showToast(data.error);
    } else if (formik && data.errors) {
      // @ts-ignore
      formik.setErrors(data.errors);
    }
  };
}
